const AccordionContainer = ({ id = 'accordionContainer', children }) => {
  return (
    <div id={id} className="accordion">
      {children}
    </div>
  );
};

export default AccordionContainer;
